<template>
  <el-card>
    <el-form :inline="true" @submit.prevent>
      <el-form-item>
        <el-input v-model.trim="keyword" placeholder="手机号/昵称" @keyup.enter="onSearch" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button @click="onReset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" stripe border v-loading="loading">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="phone" label="手机号" min-width="140" />
      <el-table-column prop="nickname" label="昵称" min-width="120" />
      <el-table-column label="主动联系" width="120">
        <template #default="{ row }">
          <el-tag :type="row.allow_proactive ? 'success' : 'warning'">{{ row.allow_proactive ? '已开启' : '已关闭' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="免打扰" min-width="150">
        <template #default="{ row }">{{ (row.dnd_start || '-') + ' ~ ' + (row.dnd_end || '-') }}</template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="180">
        <template #default="{ row }">{{ fmt(row.created_at) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="{ row }">
          <el-space>
            <el-button link type="primary" @click="openDetail(row.id)">查看</el-button>
            <el-button link type="danger" @click="resetPassword(row.id)">重置密码</el-button>
          </el-space>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 12px; display: flex; justify-content: flex-end;">
      <el-pagination
        background
        layout="total, prev, pager, next"
        :total="total"
        :current-page="query.page"
        :page-size="query.page_size"
        @current-change="onPageChange"
      />
    </div>
  </el-card>

  <el-drawer v-model="detailVisible" title="用户详情" size="760px">
    <div v-loading="detailLoading">
      <el-descriptions :column="2" border v-if="detail.user">
        <el-descriptions-item label="用户ID">{{ detail.user.id }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detail.user.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="昵称">{{ detail.user.nickname || '-' }}</el-descriptions-item>
        <el-descriptions-item label="最近登录IP">{{ detail.user.last_login_ip || '-' }}</el-descriptions-item>
        <el-descriptions-item label="最近登录时间">{{ fmt(detail.user.last_login_at) }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ fmt(detail.user.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="后台备注" :span="2">{{ detail.user.admin_note || '-' }}</el-descriptions-item>
      </el-descriptions>

      <div style="margin: 14px 0 8px; font-weight: 700;">登录记录（最近50条）</div>
      <el-table :data="detail.login_logs || []" stripe border>
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="login_ip" label="登录IP" min-width="150" />
        <el-table-column prop="user_agent" label="设备信息" min-width="320" show-overflow-tooltip />
        <el-table-column label="登录时间" min-width="180">
          <template #default="{ row }">{{ fmt(row.login_at) }}</template>
        </el-table-column>
      </el-table>
    </div>
  </el-drawer>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { adminApi } from '../api/admin'

const keyword = ref('')
const list = ref([])
const total = ref(0)
const loading = ref(false)
const detailVisible = ref(false)
const detailLoading = ref(false)
const detail = ref({
  user: null,
  login_logs: []
})
const query = ref({
  page: 1,
  page_size: 20
})

const fmt = (v) => (v ? new Date(v).toLocaleString() : '-')

async function load() {
  loading.value = true
  try {
    const data = await adminApi.users({
      keyword: keyword.value,
      page: query.value.page,
      page_size: query.value.page_size
    })
    list.value = data.list || []
    total.value = data.total || 0
  } catch (e) {
    ElMessage.error(e.message || '加载失败')
  } finally {
    loading.value = false
  }
}

function onSearch() {
  query.value.page = 1
  load()
}

function onReset() {
  keyword.value = ''
  query.value.page = 1
  load()
}

function onPageChange(page) {
  query.value.page = page
  load()
}

async function openDetail(userID) {
  detailVisible.value = true
  detailLoading.value = true
  detail.value = { user: null, login_logs: [] }
  try {
    const data = await adminApi.userDetail(userID)
    detail.value = data || { user: null, login_logs: [] }
  } catch (e) {
    ElMessage.error(e.message || '加载详情失败')
  } finally {
    detailLoading.value = false
  }
}

async function resetPassword(userID) {
  try {
    await ElMessageBox.confirm(
      `确认将用户 #${userID} 的密码重置为 123456 吗？系统会自动记录后台备注。`,
      '重置密码确认',
      { type: 'warning' }
    )
    await adminApi.resetUserPassword(userID)
    ElMessage.success('密码已重置为 123456')
    if (detailVisible.value && detail.value.user && detail.value.user.id === userID) {
      await openDetail(userID)
    }
    await load()
  } catch (e) {
    if (e === 'cancel') return
    ElMessage.error(e.message || '重置失败')
  }
}

onMounted(load)
</script>
